module.exports = __webpack_public_path__ + "img/img-aa0625b4.9887a6df.png";